import React, { useState, useEffect } from "react";
import { useQuery } from 'react-query'
import { getResultsRSC } from "data/Querys"
import { isStartListStatus } from "helpers/status";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Label from "components/general/Label"
import Loader from 'components/general/Loader'
import PageHeader from "components/common/PageHeader";
//Results
import DivResults from 'components/sports/div/views/DivResults'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";



const DivContext = () => {
    const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const [key, setKey] = useState(`1-${mirs_rsc}`);


    //DATA
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            //onError: (error) =>
            //    console.error(`Something went wrong: ${error.message}`),
        });

    const resultStatus = data?.results?.status?.code;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if (isError) { return <div >No data available</div>; }
    if (isLoading) { return <Loader />; }



    return (
        <>
            {data?.results ? (
                <>
                    <PageHeader data={data} />
                    <div className='mirs-page-container'>

                    <div className="d-flex  navbar-light  results-Header">
                        <div className="flex-grow-1"> <h2>{data?.results?.eventUnit?.description}</h2></div>
                    </div>
                    <div>{data.results.date}</div>
                    <Tabs
                        id="mirs-navsport"
                        className="mb-3 mirs-tab-result"
                        defaultActiveKey={`1-${mirs_rsc}`}
                        onSelect={(k) => setKey(k)}
                    >
                        <Tab eventKey={`1-${mirs_rsc}`} title={<Label data=
                            {isStartListStatus(resultStatus)
                                ? "HeaderStartList"
                                : "HeaderResults"
                            }
                        />} >
                            <DivResults data={data} caption={<Label data=
                                {isStartListStatus(resultStatus)
                                    ? "HeaderStartList"
                                    : "HeaderResults"
                                }
                            />} />
                        </Tab>



                    </Tabs>
                    </div>


                </>
            ) : (
                <span><em>No data available</em></span>
            )
            }
        </>
    );
};

export default DivContext;



